import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import { ICalendarLayout } from '../../types/layout/calendar';
import { useCalendar } from '../../hooks/calendar/useCalendar';

function Calendar({ data, dataLink }: ICalendarLayout) {
    const { events, getEvents } = useCalendar(dataLink);

    return (
        <div className="card card-outline">
            <div className="card-body">
                <FullCalendar
                    allDayText="Весь день"
                    noEventsText="Список задач пуст"
                    buttonText={{
                        today: 'Сегодня',
                        dayGridWeek: 'Неделя',
                        dayGridMonth: 'Месяц',
                        listMonth: 'Список',
                    }}
                    locale="ru"
                    plugins={[dayGridPlugin, interactionPlugin, listPlugin]}
                    initialView="dayGridMonth"
                    weekends
                    events={Array.isArray(events) && events.length > 0 ? events : data}
                    firstDay={1}
                    datesSet={getEvents}
                    headerToolbar={{
                        start: 'title',
                        center: '',
                        right: 'today prev,next dayGridWeek,dayGridMonth,listMonth',
                    }}
                />
            </div>
        </div>
    );
}

export default Calendar;
